/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unknown-property */
import React, { useContext, useEffect, useState } from 'react'

import { getSectionByCodeOrName } from '../../../assets/ts/data/common-metadata'
import { defaultToEmptyString, twoDigits } from '../../../assets/ts/formatting/formatting'
import useInquiryCount from '../../../hooks/inquiry/use-inquiry-count'
import { RoleContext } from '../../../store/role-context-provider'
import { UserContext } from '../../../store/user-context-provider'

interface KPIItem {
  colorCode?: string
  count?: string
  countClass?: string
  link?: string
  sectionCode?: number
  title?: string
}

interface ResponseKPIProps {
  kpiItem: KPIItem
  kpiTitle: string
  setKpiName: any
  updateKpiFilter: any
  updateTotal: (total: number) => void
}

const ResponseKPI: React.FC<ResponseKPIProps> = ({
  kpiItem,
  kpiTitle,
  setKpiName,
  updateKpiFilter,
}) => {
  const { me } = useContext(UserContext)
  const [currentSection, setCurrentSection] = useState<number | string>('')
  const {
    isAFRCOwner,
    isANGOwner,
    isCPOwner,
    isLeadership,
    isMAJCOMOwner,
    isMPFOwner,
    isRegAFOwner,
    mpfSection,
  } = useContext(RoleContext)
  const isOwnerOrLeadership = 
    isAFRCOwner ||
    isANGOwner||
    isRegAFOwner||
    isMPFOwner||
    isMAJCOMOwner||
    isCPOwner||
    isLeadership||
    isMAJCOMOwner
  

  const { inquiryCount: responseRequested } = useInquiryCount({
    activeFilter: null,
    assignedToMe: undefined,
    assignedToOther: undefined,
    currentSection: isOwnerOrLeadership ? '' : currentSection,
    customerActionRequiredFilter: null,
    elevatedToMPF: null,
    isCPOwnerOrLeadership: isOwnerOrLeadership,
    isResponsePending: false,
    isResponseRequired: true,
    notSelfFilter: me.userId,
    pendingActionOutsideFilter: null,
    returnedFromMPF: undefined,
    sectionCodeKPIFilter: kpiItem.sectionCode,
    statusCodeFilter: '',
    unassignedFilter: null,
  })

  const { inquiryCount: responsePending } = useInquiryCount({
    activeFilter: null,
    assignedToMe: undefined,
    assignedToOther: undefined,
    currentSection: isOwnerOrLeadership ? '' : currentSection,
    customerActionRequiredFilter: null,
    isCPOwnerOrLeadership: isOwnerOrLeadership,
    isResponsePending: true,
    isResponseRequired: true,
    notSelfFilter: me.userId,
    pendingActionOutsideFilter: null,
    returnedFromMPF: undefined,
    sectionCodeKPIFilter: kpiItem.sectionCode,
    statusCodeFilter: '',
    unassignedFilter: null,
  })
  const determineCount = (kpiTitle) => {
    let count = 0 // Default value for count
    switch (kpiTitle?.toLocaleLowerCase()) {
      case 'response requested':
        count = responseRequested[0]?.InquiryGUID_count || 0
        break
      case 'response pending':
        count = responsePending[0]?.InquiryGUID_count || 0
        break
      default:
        console.warn(`Unknown accordion title: ${kpiTitle}`)
    }
    return twoDigits(count)
  }
  function createResponseObject(kpiTitle) {
    if (kpiTitle?.toLocaleLowerCase() === 'response requested') {
      setKpiName(kpiTitle)
      updateKpiFilter({
        activeFilter: null,
        assignedToMe: null,
        assignedToOther: null,
        currentSection: isOwnerOrLeadership ? '' : currentSection,
        customerActionRequiredFilter: null,
        elevatedToMPF: null,
        isCPOwnerOrLeadership: isOwnerOrLeadership,
        isResponsePending: false,
        isResponseRequired: true,
        notSelfFilter: me.userId,
        pendingActionOutsideFilter: null,
        returnedFromMPF: null,
        sectionCodeKPIFilter: kpiItem.sectionCode,
        statusCodeFilter: '',
        unassignedFilter: null,
      })
    }
    if (kpiTitle?.toLocaleLowerCase() === 'response pending') {
      setKpiName(kpiTitle)
      updateKpiFilter({
        activeFilter: null,
        assignedToMe: null,
        assignedToOther: null,
        currentSection: isOwnerOrLeadership ? '' : currentSection,
        customerActionRequiredFilter: null,
        isCPOwnerOrLeadership: isOwnerOrLeadership,
        isResponsePending: true,
        isResponseRequired: true,
        notSelfFilter: me.userId,
        pendingActionOutsideFilter: null,
        returnedFromMPF: null,
        sectionCodeKPIFilter: kpiItem.sectionCode,
        statusCodeFilter: '',
        unassignedFilter: null,
      })
    }
  }

  useEffect(() => {
    const getSection = async () => {
      const section = await getSectionByCodeOrName({
        isArchivedFilter: null,
        userSections: mpfSection,
      })
      setCurrentSection(section) // Store the resolved value in state
    }

    if (mpfSection.length > 0) getSection()
  }, [mpfSection])

  return (
    <div className='col col-md-12 align-items-stretch d-flex mt-1' key={kpiItem.title}>
      <div className=' w-100 p-0'>
        <a
          aria-live='polite'
          className='p-0 align-items-center p-relative text-decoration-none d-flex flex-row w-100 kpiborder bordered2 border-radius'
          data-status-kpis={kpiItem.colorCode}
          onClick={() => createResponseObject(kpiTitle)}
          tabIndex={0}
          title={kpiItem.title}
        >
          <span className='font-11 poppins-semibold text-uppercase px-2'>
            {defaultToEmptyString(kpiItem.title)}
          </span>
          <span className={kpiItem.countClass}>
            {defaultToEmptyString(determineCount(kpiTitle))}
          </span>
        </a>
      </div>
    </div>
  )
}

export default ResponseKPI
